module.exports = __webpack_public_path__ + "static/media/push-icon.7e1fb2d6.svg";